/*
*
* File JS per la Basic Page
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroBig from 'components/hero-big/hero-big';
import heroImage from 'imComponents/hero-image/hero-image';

// COMPONENTI CUSTOM BLOCKS
import blockText from 'components/block-text/block-text';
import blockImage from 'components/block-image/block-image';
import scrollBanner from 'components/scroll-banner/scroll-banner';
import blockGallery from 'components/block-gallery/block-gallery';
import blockAltTextImage from 'components/block-alt-text-image/block-alt-text-image';
import blockEmbed from 'imComponents/block-embed/block-embed';
import blockVideo from 'imComponents/block-video/block-video';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './basic-page.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

blockGallery();
blockVideo();

//--------------------------------------------------------------------//